import React from 'react';
import ToolbarPopover from './ToolbarPopover';

const densityOptions = [
  { value: 'compact', label: 'Compact' },
  { value: 'standard', label: 'Standard' },
  { value: 'comfortable', label: 'Comfortable' }
];

const DensityPopover = ({
  id,
  open,
  anchorEl,
  onClose,
  onDensityChange,
  currentDensity
}) => {
  return (
    <ToolbarPopover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      title="Row Density"
    >
      <div className="p-4 space-y-2">
        {densityOptions.map(option => (
          <button
            key={option.value}
            onClick={() => {
              onDensityChange?.(option.value);
              onClose?.();
            }}
            className={`w-full px-4 py-2 text-sm font-medium rounded-md ${
              currentDensity === option.value
                ? 'bg-indigo-100 text-indigo-700 border border-indigo-300'
                : 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300'
            }`}
          >
            {option.label}
          </button>
        ))}
      </div>
    </ToolbarPopover>
  );
};

export default React.memo(DensityPopover);
